export const smartButtonExtensionType = 'com.atlassian.automation.smart-button';
